import { render, staticRenderFns } from "./newEditor.vue?vue&type=template&id=2f6904c9&scoped=true&"
import script from "./newEditor.vue?vue&type=script&lang=js&"
export * from "./newEditor.vue?vue&type=script&lang=js&"
import style0 from "./newEditor.vue?vue&type=style&index=0&id=2f6904c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6904c9",
  null
  
)

export default component.exports